<template>
  <div class="RelatedStaff">
    <div class="content flex-jc-bt">
      <div class="flex-48 left-side">
        <sp-card type="none" custom-class="sp-color-bg-4">
          <div class="card-content">
            <div v-triangle class="text-left">
              {{ $l('JobTitleDescription') }}
            </div>
            <div v-if="jobInfo.profession" class="pd-l-20 text-left">
              <div class="mg-t-30">
                <div class="pd-b-10">{{ $l('DeptAccessIdentity') }}</div>
                <sp-input v-model="identityInfo" :disabled="true" type="gray" :width="0.5" />
              </div>
              <div class="mg-t-20">
                <div class="pd-b-10">{{ $l('Responsibility') }}</div>
                <sp-input v-model="jobInfo.profession.name" :disabled="true" type="gray" :width="0.5" />
              </div>
              <div class="mg-t-20">
                <div class="pd-b-10">{{ $l('Position') }}</div>
                <sp-input v-model="jobInfo.position.name" :disabled="true" type="gray" :width="0.5" />
              </div>
            </div>
            <div class="mg-t-20 pd-l-20 pd-r-40">
              <div class="text-left">
                {{ $l('JobDescription') }}
                <div class="pd-t-10">
                  <sp-input v-model="jobInfo.description" :disabled="true" type="gray" text-type="textArea" row="6" />
                </div>
              </div>
            </div>
          </div>
        </sp-card>
      </div>
      <div class="flex-50 right-side sp-color-bg-4">
        <div class="pd-b-20 pd-t-40 text-left">
          {{ $l('StaffConfiguration') }}
        </div>
        <SpTableDIY :data-list="dataList">
          <SpTableColumn column-name="name" label="MyName">
            <template #default="row">
              <div>{{ row.employee?.fullName }}</div>
              <div class="attach">
                {{ row.employee?.nativeName }}
              </div>
            </template>
          </SpTableColumn>
          <SpTableColumn column-name="FamilyName" label="FamilyName">
            <template #default="row">
              {{ row.employee?.lastName }}
            </template>
          </SpTableColumn>
          <SpTableColumn column-name="StartingDate" label="StartingDate">
            <template #default="row">
              {{ getDateToFormatEn(row.hiredAt) }}
            </template>
          </SpTableColumn>
        </SpTableDIY>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spCard from '@/components/common/SpCard'
import spInput from '@/components/common/SpInput'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import { DEPT_IDENTITY } from '@/config/company'
import { getEnterpriseJobWorkerListApi } from '@/request/APIs/company'
import { getDateToFormatEn } from '@/utils/convert'
export default {
  name: 'RelatedStaff',
  nameSpace: 'company.PermissionsSetting.RelatedStaffName',
  components: {
    spCard,
    spInput,
    spSelect,
    spSelectOption,
    SpTableDIY,
    SpTableColumn
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data () {
    return {
      dataList: [],
      getDateToFormatEn,
      identityOptions: DEPT_IDENTITY
    }
  },

  computed: {
    jobInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    },

    identityInfo () {
      return this.identityOptions[this.jobInfo.identity]?.title
    }
  },

  created () {
    this.getWokerList()
  },

  mounted () {
  },

  methods: {
    getWokerList () {
      if (!this.jobInfo.id) return false
      getEnterpriseJobWorkerListApi(this.jobInfo.id).then(res => {
        this.dataList = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
.RelatedStaff {
    .content {
        padding: @gap/1.5 @gap @gap @gap*2;
        .left-side {
            .card-content {
                padding: @gap*1.5;
            }
        }
        .right-side {
            padding: @gap @gap*2 @gap @gap*1.5;
            box-sizing: border-box;
            .attach{
                color: #676767;
                font-size: 14px;
            }
        }
    }
}
</style>
